import React from 'react';
import cx from 'classnames';
import moment from 'moment';

import bannerMobilePng from '@/shared/assets/banners/btc-banner-m.png';
import bannerDesktopPng from '@/shared/assets/banners/btc-banner-d.png';

const link = 'https://hiveon.net/?utm_source=pool&utm_medium=banner&utm_campaign=btc_pool';
const endDate = moment('2025-12-18');
const BannerTop = () => {
  const isExpired = moment().isAfter(endDate);

  console.log(bannerDesktopPng);
  return isExpired ? null : (
    <a href={link} target='_blank' className="flex justify-center">
      <div 
        className="overflow-hidden relative hidden md:block w-full bg-center bg-contain bg-no-repeat h-[60px] bg-[#03051C]">
        <img src={bannerDesktopPng.src} alt="banner" className="m-0 h-full absolute top-0 bottom-0 left-1/2 -translate-x-1/2 min-w-[1919px]" />
      </div>
      <div 
        className="relative block md:hidden w-full bg-center bg-contain bg-no-repeat h-[60px] bg-[#03051C]"
      >
        <img src={bannerMobilePng.src} alt="banner" className="m-0 h-full absolute top-0 bottom-0 left-1/2 -translate-x-1/2 min-w-[591px]" />
      </div>
    </a>
  )
};

export default BannerTop;
